export default[

    {
        "id": 1223421,
        "name": "Western Province",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.083328,
            "lat": 6.83333
        }
    },
    {
        "id": 1223488,
        "name": "Weragampita",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.550003,
            "lat": 5.95
        }
    },
    {
        "id": 1223648,
        "name": "Welisara",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.901398,
            "lat": 7.0281
        }
    },
    {
        "id": 1223738,
        "name": "Weligama",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.416672,
            "lat": 5.96667
        }
    },
    {
        "id": 1224061,
        "name": "Wattegama",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.480797,
            "lat": 6.7989
        }
    },
    {
        "id": 1224085,
        "name": "Wattala",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.889801,
            "lat": 6.9779
        }
    },
    {
        "id": 1225018,
        "name": "Vavuniya",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.497101,
            "lat": 8.7514
        }
    },
    {
        "id": 1225142,
        "name": "Valvedditturai",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.166672,
            "lat": 9.81667
        }
    },
    {
        "id": 1225265,
        "name": "Province of Uva",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.25,
            "lat": 7.0
        }
    },
    {
        "id": 1226260,
        "name": "Trincomalee",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.233498,
            "lat": 8.5711
        }
    },
    {
        "id": 1226391,
        "name": "Tirukkalkudah",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.188698,
            "lat": 8.5421
        }
    },
    {
        "id": 1226494,
        "name": "Timbirigasyaya",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.865501,
            "lat": 6.8888
        }
    },
    {
        "id": 1226992,
        "name": "Taralanda",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.6241,
            "lat": 7.4726
        }
    },
    {
        "id": 1227037,
        "name": "Tangalle",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.7911,
            "lat": 6.024
        }
    },
    {
        "id": 1227109,
        "name": "Tammannekulama",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.433327,
            "lat": 8.3
        }
    },
    {
        "id": 1227300,
        "name": "Talawakele",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.658096,
            "lat": 6.9371
        }
    },
    {
        "id": 1227603,
        "name": "Democratic Socialist Republic of Sri Lanka",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.0,
            "lat": 7.0
        }
    },
    {
        "id": 1227618,
        "name": "Southern Province",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.75,
            "lat": 6.16667
        }
    },
    {
        "id": 1227667,
        "name": "Slave Island",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.849998,
            "lat": 6.91667
        }
    },
    {
        "id": 1228051,
        "name": "Sigiriya",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.742599,
            "lat": 7.9518
        }
    },
    {
        "id": 1228435,
        "name": "Sabaragamuwa Province",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.5,
            "lat": 6.75
        }
    },
    {
        "id": 1228730,
        "name": "Ratnapura",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.39917,
            "lat": 6.68278
        }
    },
    {
        "id": 1229293,
        "name": "Puttalam",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.8283,
            "lat": 8.0362
        }
    },
    {
        "id": 1229554,
        "name": "Puliyadikuda",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.699997,
            "lat": 7.71667
        }
    },
    {
        "id": 1229901,
        "name": "Polonnaruwa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.0,
            "lat": 7.93333
        }
    },
    {
        "id": 1229989,
        "name": "Point Pedro",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.23333,
            "lat": 9.81667
        }
    },
    {
        "id": 1230089,
        "name": "Pita Kotte",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.901497,
            "lat": 6.8905
        }
    },
    {
        "id": 1230613,
        "name": "Peliyagoda",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.883598,
            "lat": 6.9685
        }
    },
    {
        "id": 1231410,
        "name": "Panadura",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.902603,
            "lat": 6.7132
        }
    },
    {
        "id": 1231644,
        "name": "Pallimulla",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.550003,
            "lat": 5.95
        }
    },
    {
        "id": 1232783,
        "name": "Nuwara Eliya",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.78286,
            "lat": 6.97078
        }
    },
    {
        "id": 1232860,
        "name": "North Western Province",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.166672,
            "lat": 7.75
        }
    },
    {
        "id": 1232870,
        "name": "North Central Province",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.5,
            "lat": 8.33333
        }
    },
    {
        "id": 1233163,
        "name": "New Town",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.0,
            "lat": 7.91667
        }
    },
    {
        "id": 1233369,
        "name": "Negombo",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.8358,
            "lat": 7.2083
        }
    },
    {
        "id": 1234378,
        "name": "Mulleriyawa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.929703,
            "lat": 6.933
        }
    },
    {
        "id": 1234633,
        "name": "Moratuwa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.881599,
            "lat": 6.773
        }
    },
    {
        "id": 1234808,
        "name": "Monaragala",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.348701,
            "lat": 6.8714
        }
    },
    {
        "id": 1234846,
        "name": "Mohottiwatta",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.037804,
            "lat": 6.2681
        }
    },
    {
        "id": 1235000,
        "name": "Minuwangoda",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.9533,
            "lat": 7.1663
        }
    },
    {
        "id": 1235846,
        "name": "Matara",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.535278,
            "lat": 5.94851
        }
    },
    {
        "id": 1236150,
        "name": "Mannar",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.900002,
            "lat": 8.98333
        }
    },
    {
        "id": 1236854,
        "name": "Maharagama",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.926498,
            "lat": 6.848
        }
    },
    {
        "id": 1237980,
        "name": "Kurunegala",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.362297,
            "lat": 7.4863
        }
    },
    {
        "id": 1238367,
        "name": "Kumbalwella",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.210098,
            "lat": 6.0565
        }
    },
    {
        "id": 1238427,
        "name": "Kuliyapitiya",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.0401,
            "lat": 7.4688
        }
    },
    {
        "id": 1238992,
        "name": "Sri Jayewardenepura Kotte",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.908333,
            "lat": 6.90278
        }
    },
    {
        "id": 1239047,
        "name": "Kotikawatta",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.9095,
            "lat": 6.9269
        }
    },
    {
        "id": 1239593,
        "name": "Kolonnawa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.884804,
            "lat": 6.9329
        }
    },
    {
        "id": 1240372,
        "name": "Kilinochchi",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.398201,
            "lat": 9.3961
        }
    },
    {
        "id": 1240622,
        "name": "Kelaniya",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.921997,
            "lat": 6.9553
        }
    },
    {
        "id": 1240935,
        "name": "Katunayaka",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.875702,
            "lat": 7.1643
        }
    },
    {
        "id": 1241622,
        "name": "Kandy",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.635597,
            "lat": 7.2955
        }
    },
    {
        "id": 1241750,
        "name": "Kandana",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.8937,
            "lat": 7.048
        }
    },
    {
        "id": 1241964,
        "name": "Kalutara",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.959297,
            "lat": 6.5831
        }
    },
    {
        "id": 1242110,
        "name": "Kalmunai",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.816673,
            "lat": 7.41667
        }
    },
    {
        "id": 1242170,
        "name": "Kallady",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.716301,
            "lat": 7.7124
        }
    },
    {
        "id": 1242571,
        "name": "Kadugannawa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.5242,
            "lat": 7.2547
        }
    },
    {
        "id": 1242833,
        "name": "Jaffna",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.007423,
            "lat": 9.66845
        }
    },
    {
        "id": 1242835,
        "name": "Ja Ela",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.891899,
            "lat": 7.0744
        }
    },
    {
        "id": 1243867,
        "name": "Horana South",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.062599,
            "lat": 6.7159
        }
    },
    {
        "id": 1243936,
        "name": "Homagama",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.002403,
            "lat": 6.844
        }
    },
    {
        "id": 1244108,
        "name": "Hingurakgoda",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.949997,
            "lat": 8.03333
        }
    },
    {
        "id": 1244178,
        "name": "Hikkaduwa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.101196,
            "lat": 6.1407
        }
    },
    {
        "id": 1244397,
        "name": "Hendala",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.883003,
            "lat": 6.9909
        }
    },
    {
        "id": 1244596,
        "name": "Hatton",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.595497,
            "lat": 6.8916
        }
    },
    {
        "id": 1244713,
        "name": "Haputale",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.959541,
            "lat": 6.76812
        }
    },
    {
        "id": 1244773,
        "name": "Hanwella Ihala",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.085197,
            "lat": 6.9012
        }
    },
    {
        "id": 1244926,
        "name": "Hambantota",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.1185,
            "lat": 6.1241
        }
    },
    {
        "id": 1246000,
        "name": "Gampola",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.569603,
            "lat": 7.1643
        }
    },
    {
        "id": 1246007,
        "name": "Gampaha",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.9925,
            "lat": 7.0897
        }
    },
    {
        "id": 1246294,
        "name": "Galle",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.217003,
            "lat": 6.0367
        }
    },
    {
        "id": 1246321,
        "name": "Galkissa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.862999,
            "lat": 6.8293
        }
    },
    {
        "id": 1246924,
        "name": "Eravur Town",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.603798,
            "lat": 7.7782
        }
    },
    {
        "id": 1248749,
        "name": "Dambulla",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.651672,
            "lat": 7.86
        }
    },
    {
        "id": 1248991,
        "name": "Colombo",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.847778,
            "lat": 6.93194
        }
    },
    {
        "id": 1249145,
        "name": "Chilaw",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.79528,
            "lat": 7.57583
        }
    },
    {
        "id": 1249296,
        "name": "Central Province",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.75,
            "lat": 7.33333
        }
    },
    {
        "id": 1249931,
        "name": "Beruwala",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.982803,
            "lat": 6.4788
        }
    },
    {
        "id": 1249978,
        "name": "Bentota",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.994797,
            "lat": 6.4254
        }
    },
    {
        "id": 1250161,
        "name": "Batticaloa",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.692398,
            "lat": 7.7102
        }
    },
    {
        "id": 1250164,
        "name": "Battaramulla South",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 79.918098,
            "lat": 6.8964
        }
    },
    {
        "id": 1250615,
        "name": "Badulla",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.055702,
            "lat": 6.9895
        }
    },
    {
        "id": 1251081,
        "name": "Anuradhapura",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.417259,
            "lat": 8.35647
        }
    },
    {
        "id": 1251459,
        "name": "Ampara",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 81.666672,
            "lat": 7.28333
        }
    },
    {
        "id": 1251574,
        "name": "Ambalangoda",
        "state": "",
        "country": "LK",
        "coord": {
            "lon": 80.053802,
            "lat": 6.2355
        }
    }
];